export default "__VITE_ASSET__7ATI2PpH__"